/* eslint-disable security/detect-object-injection */
/* istanbul ignore file */
// TextArea.js
import React from 'react';
import '../../styles.css'

function Table({ component }) {
    return (
        <div className='property-options form-table'>
            <div style={{ width: component?.styles?.width }}>
                <table className='w-full'>
                    {component.showTableHeaders === true && <thead data-testid="table_header">
                        <tr>
                            {component.headers.map((header, index) => (
                                <th key={index} 
                                    style={{
                                        padding:'4px', ...component?.cellFormats[index], backgroundColor: component?.cellFormats[index]?.backgroundColor || 'white',
                                    }} 
                                    colSpan={header.colspan}
                                    rowSpan={header.rowspan}
                                    className={`cell`}
                                >
                                    <div className='flex items-center justify-center'>
                                        <textarea
                                            className='font-normal'
                                            id={`textarea-${index}`}
                                            value={header.value || ''}
                                            style={{...component?.cellFormats[index],
                                                width: '100%',
                                                border: 'none',
                                                outline: 'none',
                                                resize: 'none', // Prevent manual resize
                                                overflow: 'hidden', // Hide scrollbars
                                                fontSize: component?.cellFormats[index]?.fontSize || '14px',
                                                color: component?.cellFormats[index]?.color || 'black',
                                                backgroundColor: component?.cellFormats[index]?.backgroundColor || 'white',
                                                height: header.styles.height || 'auto',
                                            }}
                                            rows={1} // Initial rows
                                        />
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    }
                    <tbody>
                        {component.rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, columnIndex) => (
                                    <>
                                        <td
                                            key={columnIndex}
                                            colSpan={cell.colspan}
                                            rowSpan={cell.rowspan}
                                            style={{padding: '4px', ...component?.cellFormats[`${rowIndex}-${columnIndex}`], backgroundColor: component?.cellFormats[`${rowIndex}-${columnIndex}`]?.backgroundColor || 'white',}}
                                            className={`cell font-normal`}
                                        >
                                            <div className='flex items-center justify-center'>
                                                <textarea
                                                    id={`textarea-${rowIndex}-${columnIndex}`}
                                                    data-testid={`cell-${rowIndex}-${columnIndex}`}
                                                    value={cell.value || ''}
                                                    style={{
                                                        ...component?.cellFormats[`${rowIndex}-${columnIndex}`],
                                                        width: '100%',
                                                        border: 'none',
                                                        outline: 'none',
                                                        resize: 'none', // Prevent manual resize
                                                        overflow: 'hidden', // Hide scrollbars
                                                        fontSize: component?.cellFormats[`${rowIndex}-${columnIndex}`]?.fontSize || '14px',
                                                        color: component?.cellFormats[`${rowIndex}-${columnIndex}`]?.color || 'black',
                                                        backgroundColor: component?.cellFormats[`${rowIndex}-${columnIndex}`]?.backgroundColor || 'white',
                                                        height: cell.styles.height || 'auto',
                                                    }}
                                                    rows={1} // Initial rows
                                                />
                                            </div>
                                        </td>
                                    </>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Table;